import store from '@/store'
import userStore from '@/store/modules/user.store'
import { extractRedirect, routerState } from '../utils'

async function isUserSubscribed() {
  if (userStore.state.isProfileLoaded) {
    return store.state.user.isSubscribed
  }

  await new Promise(resolve => {
    const unwatch = store.watch(
      state => state.user.isProfileLoaded,
      loaded => {
        if (loaded) {
          unwatch()
          resolve()
        }
      }
    )
    if (userStore.state.isProfileLoaded) {
      unwatch()
      resolve()
    }
  })

  return store.state.user.isSubscribed
}

export default async (to, from, next) => {
  const isSubscribed = await isUserSubscribed()
  const unauthorizedRedirect = extractRedirect(to, 'unauthorized')
  const authorizedRedirect = extractRedirect(to, 'authorized')

  if (!isSubscribed && unauthorizedRedirect) {
    next(unauthorizedRedirect)
    return routerState.REDIRECTED
  }

  if (isSubscribed && authorizedRedirect) {
    next(authorizedRedirect)
    return routerState.REDIRECTED
  }

  return routerState.ALLOWED
}
